import React from 'react';
import { TitrationRowRendererProps } from './utils/Constants';
import { Input } from 'components/input';

export const TitrationRowRenderer = ({
  bufferDataPoints,
  handleDataPointChange,
}: TitrationRowRendererProps) => {
  const tableRows = () =>
    bufferDataPoints.map((bdp) => {
      return {
        id: bdp.id,
        pH: (
          <Input
            id="titrationrowrenderer-input-ph"
            name="ph"
            className="w-full border-none bg-transparent text-center h-8"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const newPh = parseInt(e.target.value);
              if (e.target.value === '' || (newPh >= 0 && newPh <= 14)) {
                handleDataPointChange(e, bdp.id);
              }
            }}
            onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (!bdp.ph) {
                e.target.value = '0';
                handleDataPointChange(e, bdp.id);
              }
            }}
            value={bdp.ph}
            type="number"
          />
        ),
        ratio: (
          <Input
            id="titrationrowrenderer-input-ratio"
            name="ratio"
            className="w-full border-none bg-transparent text-center h-8"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleDataPointChange(e, bdp.id);
            }}
            value={bdp.ratio}
            type="number"
          />
        ),
      };
    });
  return tableRows();
};
